import { useQuery } from "@tanstack/react-query";
import { deltamathAPI } from "../../manager/utils";
import axios from "axios";

const NonSuperAdminCredentials = () => {
  const { data } = useQuery({
    queryKey: ["nonSuperAdminCredentials"],
    queryFn: async () => {
      const response = await axios.post(
        deltamathAPI() + "/admin_new/data/superAdminName"
      );
      return response.data;
    },
  });

  return (
    <div className="max-w-md">
      <p>
        The Key and Secret for this integration are housed within{" "}
        {data?.superAdmin?.first} {data?.superAdmin?.last}&apos;s account since
        they are the primary admin.
      </p>
    </div>
  );
};

export default NonSuperAdminCredentials;
